import React from 'react';
import { Heart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useWatchlist } from '../context/WatchlistContext';
import { toast } from '../hooks/use-toast';

export default function WatchButton({ type, id, className = '', size = 15 }) {
  const { isWatched, toggle } = useWatchlist();
  const navigate = useNavigate();
  const watched = isWatched(type, id);

  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const res = await toggle(type, id);
    if (res === 'auth') {
      toast({ title: 'Sign in to save items', description: 'Create a free account to build your watchlist.' });
      navigate('/login');
    } else if (res === 'added') {
      toast({ title: 'Added to your watchlist' });
    } else {
      toast({ title: 'Removed from watchlist' });
    }
  };

  return (
    <button
      onClick={onClick}
      aria-label={watched ? 'Remove from watchlist' : 'Add to watchlist'}
      data-testid={`watch-btn-${type}-${id}`}
      className={`grid place-items-center w-8 h-8 rounded-full shadow-sm transition-colors ${watched ? 'bg-[#e11d2c] text-white' : 'bg-white/95 text-black hover:text-[#e11d2c]'} ${className}`}
    >
      <Heart size={size} fill={watched ? 'currentColor' : 'none'} />
    </button>
  );
}
